(() => {
  if (document.querySelector('.nekoan-privacy-backdrop')) return;
  const backdrop = document.createElement('div');
  backdrop.className = 'nekoan-privacy-backdrop';
  backdrop.hidden = true;
  backdrop.setAttribute('aria-hidden', 'true');
  document.body.append(backdrop);
  let frame = 0;
  const visible = element => Boolean(element && element.getClientRects().length && getComputedStyle(element).display !== 'none' && getComputedStyle(element).visibility !== 'hidden');
  const sync = () => {
    frame = 0;
    const open = visible(document.getElementById('shopify-pc__banner'));
    const preferencesOpen = visible(document.getElementById('shopify-pc__prefs__dialog'));
    const showBackdrop = open && !preferencesOpen;
    if (backdrop.hidden === showBackdrop) backdrop.hidden = !showBackdrop;
    const lockScroll = open || preferencesOpen;
    if (document.body.classList.contains('nekoan-privacy-open') !== lockScroll) {
      document.body.classList.toggle('nekoan-privacy-open', lockScroll);
    }
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(sync);
  };
  const privacyId = node => typeof node?.id === 'string' && node.id.startsWith('shopify-pc__');
  const privacyNode = node => node.nodeType === 1 && (privacyId(node) || node.querySelector?.('[id^="shopify-pc__"]'));
  new MutationObserver(records => {
    if (records.some(record => record.type === 'attributes'
      ? privacyId(record.target) || record.target.closest?.('[id^="shopify-pc__"]')
      : (privacyId(record.target) || record.target.closest?.('[id^="shopify-pc__"]')) || [...record.addedNodes, ...record.removedNodes].some(privacyNode))) schedule();
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden', 'aria-hidden', 'class']});
  let opening = false;
  const waitFor = (check, timeout) => new Promise((resolve, reject) => {
    const deadline = Date.now() + timeout;
    const poll = () => {
      const result = check();
      if (result) return resolve(result);
      if (Date.now() >= deadline) return reject(new Error('Privacy preferences unavailable'));
      setTimeout(poll, 100);
    };
    poll();
  });
  document.addEventListener('click', async event => {
    const link = event.target.closest('.nekoan-cookie-settings a[href="#shopifyReshowConsentBanner"]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (opening) return;
    opening = true;
    link.setAttribute('aria-busy', 'true');
    const status = document.getElementById('NekoanCookieStatus');
    if (status) {
      status.hidden = true;
      status.textContent = '';
    }
    try {
      const banner = await waitFor(() => typeof window.privacyBanner?.showPreferences === 'function' && window.privacyBanner, 5000);
      await Promise.race([
        Promise.resolve().then(() => banner.showPreferences()),
        new Promise((_, reject) => setTimeout(() => reject(new Error('Privacy preferences timed out')), 5000))
      ]);
      await waitFor(() => visible(document.getElementById('shopify-pc__prefs__dialog')), 3000);
      schedule();
    } catch (_) {
      if (status) {
        status.textContent = status.dataset.unavailable;
        status.hidden = false;
      }
    } finally {
      opening = false;
      link.removeAttribute('aria-busy');
    }
  }, true);
  document.addEventListener('visitorConsentCollected', schedule);
  sync();
})();

